'use client';

import { styled } from '@linaria/react';
import { decode } from 'he';
import useTypewriter from '@fe-news/hooks/use-type-writer';
import { sanitize } from 'isomorphic-dompurify';

const Container = styled.main`
  margin-top: 12px;
`;

const Cursor = styled.span`
  display: inline-block;
  width: 4px;
  height: 12px;
  background-color: #848d97;
  margin-left: 2px;
  animation: blink 0.5s step-end infinite;

  @keyframes blink {
    50% {
      opacity: 0;
    }
  }
`;

const Text = styled.p`
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: 0.5px;
  color: #383838;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ArticleContent = ({ content }: { content: string }) => {
  const sanitizedHtml = sanitize(content);
  const decodedHtml = decode(sanitizedHtml);

  const { displayText } = useTypewriter({
    content: decodedHtml
  });

  return (
    <Container>
      <Text>
        {displayText}
        <Cursor />
      </Text>
    </Container>
  );
};

export default ArticleContent;
